export default "__VITE_ASSET__D2d2XV8P__"